import { FormBlock } from '@qbe/ads-blocks-forms';
import { FormGroupLabel, NumericFormat, Typography } from '@qbe/ads-core';
import { useAppContent, useBusinessDetails } from 'hooks';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ContextualHelpWithButton } from '~/components-ds/ContextualHelp/ContextualHelpWithButton';
import { LiabilityForm } from '~/steps/CoverDetailsLiability/types';

const UseOfContractors: React.FC = () => {
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.coverDetailsBusinessLiability',
  });

  const { control } = useFormContext<Pick<LiabilityForm, 'useOfContractors'>>();
  const { annualTurnover } = useBusinessDetails();

  return (
    <>
      <FormGroupLabel
        disableBlockPadding
        title={getTextContent('fields.useOfContractorsInput.title')}
        alignCenter
        titleSuffix={
          <ContextualHelpWithButton tracking="help: How much will you pay to contractors over the next 12 months?">
            <Typography>
              {getJSXContent('contextualhelpers.useOfContractorsInput.description')}
            </Typography>
          </ContextualHelpWithButton>
        }
      />

      <Controller
        control={control}
        render={({ field, fieldState }) => {
          const isError = Boolean(fieldState.error);

          let statusText;
          if (isError) {
            statusText =
              fieldState.error?.message ||
              getTextContent('fields.useOfContractorsInput.invalidTurnover');
          } else {
            statusText = getTextContent('fields.useOfContractorsInput.helperText');
          }
          return (
            <FormBlock preset="input">
              <NumericFormat
                id="useOfContractors"
                name="useOfContractors"
                error={isError}
                displayIcon
                // customInput={TextField}
                helperText={statusText}
                required
                thousandSeparator
                label={getTextContent('fields.useOfContractorsInput.label')}
                allowNegative={false}
                onValueChange={(values) => field.onChange(values.floatValue)}
                value={field.value !== undefined && field.value !== null ? String(field.value) : ''}
                inputRef={field.ref}
                decimalScale={0}
                data-track="use of contractor"
                data-track-value="mask"
                prefix="$ "
              />
            </FormBlock>
          );
        }}
        name="useOfContractors"
        rules={{
          required: true,
          max: {
            value: annualTurnover!,
            message: getTextContent('fields.useOfContractorsInput.cannotExceedTurnover'),
          },
        }}
      />
    </>
  );
};
export default UseOfContractors;
